module.exports = __webpack_public_path__ + "assets/img/2.284a3a96.png";